import React from "react";

export default function PostCreateForm({
  newTitle = "",
  newPostKind = "",
  setNewTitle,
  createErr,
  onAdd,
}) {
  const titlePlaceholder = newPostKind
    ? `New ${newPostKind} title...`
    : "New title...";

  const handleAdd = () => {
    if (!newPostKind) return;
    onAdd({ title: newTitle, kind: newPostKind });
  };

  return (
    <div className="create-section">
      <div className="create-row">
        <label className="form-label title-field">
          Title
          <input
            type="text"
            placeholder={titlePlaceholder}
            value={newTitle}
            onChange={(event) => setNewTitle(event.target.value)}
            onKeyDown={(event) => event.key === "Enter" && handleAdd()}
            className="title-input"
          />
        </label>

        <button
          type="button"
          onClick={handleAdd}
          className="add-btn"
          disabled={!newPostKind}
        >
          Add
        </button>
      </div>

      {createErr && <div className="create-error">{createErr}</div>}
    </div>
  );
}
